"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectStore = void 0;
const operators_1 = require("rxjs/operators");
const store_1 = require("./store");
class ObjectStore extends store_1.Store {
    constructor(initialValue) {
        super(initialValue);
        this.initialValue = initialValue;
    }
    get empty$() {
        return this.value$.pipe((0, operators_1.map)((value) => value === undefined || value.length === 0));
    }
    /**
     * Returns a model from local store or undefined if not found
     */
    getById(id) {
        var _a;
        return (_a = this.value) === null || _a === void 0 ? void 0 : _a.find((m) => m.id === id);
    }
    hasId(id) {
        return this.getById(id) !== undefined;
    }
    addValue(model) {
        this.addValues([model]);
    }
    addValues(models) {
        super.updateValue((previousValues) => {
            if (previousValues === undefined)
                previousValues = [];
            for (const model of models) {
                if (model.id === undefined) {
                    previousValues.push(model);
                }
                else if (previousValues.find((m) => m.id === model.id) === undefined)
                    previousValues.push(model);
                // add new
                else
                    previousValues[previousValues.findIndex((m) => m.id === model.id)] = model; // refresh existing
            }
            return previousValues;
        }, false);
    }
}
exports.ObjectStore = ObjectStore;
